import { useEffect, useState } from "react";
import "./OnlneBookingModal.css";
import cssClasses from "../Home/Home.module.css";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, Link, Typography, useMediaQuery } from "@mui/material";
import { Await, useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import UnitNotAvailableModal from "./UnitNotAvailableModal";
import axios from "axios";
import UnitUnavailableDialog from "./UnitUnavailableDialog";
import AllotmentSuccessModal from "./AllotmentSucessModal";
const ConfirmUnitModal = ({
  isOpen,

  onClose,
  unitData,
  paymentId,
  tokenNo
}) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const navigate = useNavigate();
  //   const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
 const [openDialog, setOpenDialog] = useState(false);
 const [falseStatus,setFalseStatus]= useState(null);
 const [isModalOpenForRPC, setIsModalOpenForRPC] = useState(false);
 const [loading,setLoading]=useState(false);
const [showSuccessModal, setShowSuccessModal] = useState(false)
console.log("ConfirmUnitModal Props:", { unitData, paymentId, tokenNo });
  const handleOpenDialog = (e) => {
    e.preventDefault();
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
const handleCloseDialogForRPC =()=>{
setIsModalOpenForRPC(false)
}

  if (!isOpen) return null;
   console.log("unitId:", unitData?.unitId);
      console.log("PaymentId:", paymentId);
      
    const handleConfirm = async () => {
    setLoading(true); // ⏳ start loader
    try {
      console.log("unitId:", unitData?.unitId);
      console.log("PaymentId:", paymentId);

      // Store in sessionStorage
      sessionStorage.setItem("unitId", unitData?.unitId);
      sessionStorage.setItem("paymentId", paymentId);

      // 1️⃣ Update booking status
      console.log("Updating booking status via RPC...", {
        statusid: unitData?.inventoryStatusId,
        unitid: unitData?.unitId,
        leadid: unitData?.leadId,
        unitholdtime: '1759902274404', 
      });

      const updateUnitBookingStatusResponse = await supabase.rpc(
        "updateunitbookingstatus",
        {
          statusid: unitData?.inventoryStatusId,
          unitid: unitData?.unitId,
          leadid: unitData?.leadId,
          unitholdtime: '1759902274404', 
        }
      );

      console.log(
        "updateUnitBookingStatusResponse:",
        updateUnitBookingStatusResponse
      );

      if (updateUnitBookingStatusResponse.data === "Unsuccessful") {
        setIsModalOpenForRPC(true);
        return;
      }

      if (updateUnitBookingStatusResponse.data === "Successful") {
        let allotResponse;
        console.log("paymentId: paymentId =========> ", paymentId);
        
        try {
          allotResponse = await axios.post(
            `${process.env.REACT_APP_PAYMENT_LINK_URL}customerOnlineBooking/customerAllotUnit`,
            {
              unitId: unitData?.unitId,
              paymentId: paymentId,
            }
          );
          console.log("Allot Unit API Response:", allotResponse.data);

          if (allotResponse.data?.success === true) {
            const frontendUnitId = sessionStorage.getItem("unitId");
            const frontendPaymentId = sessionStorage.getItem("paymentId");

            const idsMatch =
              frontendUnitId === String(allotResponse.data?.unitId) &&
              frontendPaymentId === String(allotResponse.data?.paymentId);

            console.log("IDs Match:", idsMatch);

           if (idsMatch && allotResponse.data?.allotmentPaymentId) {
  console.log("✅ Allotment success – showing success modal");

  // Show success modal for 2.5s, then navigate
  setShowSuccessModal(true);
  setTimeout(() => {
    setShowSuccessModal(false);
    sessionStorage.setItem("fromAllotmentConfirm", "true");
    navigate("/Home/Allotments");
  }, 3000);

  return;
}
          } else {
            setFalseStatus(allotResponse?.data?.error);
            setIsModalOpen(true);
          }
        }
         catch (allotError) {
  console.error("Error in allotUnit API:", allotError);

  const frontendUnitId = sessionStorage.getItem("unitId");
  const frontendPaymentId = sessionStorage.getItem("paymentId");

  const idsMatch =
    frontendUnitId === String(allotError?.response?.data?.unitId) &&
    frontendPaymentId === String(allotError?.response?.data?.paymentId);

  console.log("IDs Match:", idsMatch);

  if (idsMatch && allotError?.response?.data?.allotmentPaymentId) {
    navigate("/Home/Allotments");
    return;
  }

  // ✅ Fix: use message instead of error
  setFalseStatus(
    allotError?.response?.data?.error ||
      "Something went wrong. Please try again."
  );
  setIsModalOpen(true);
}
      }
    } catch (error) {
      console.error("Error in handleConfirm:", error);
      setIsModalOpen(true);
    } finally {
      setLoading(false); // ✅ stop loader
    }
  };


  function formatIndianNumber(number) {
    if (isNaN(number)) return number;

    const [integerPart, decimalPart] = number.toString().split(".");

    // Add commas according to the Indian numbering system
    const formattedInteger = integerPart
      .replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")
      .replace(/^(\d{1,2}),/, "$1,"); // Adjust for the first two digits

    return decimalPart
      ? `${formattedInteger}.${decimalPart}`
      : formattedInteger;
  }

    // ✅ Hide everything when success modal is shown
  if (showSuccessModal) {
    return <AllotmentSuccessModal open={showSuccessModal} />;
  }

 
  return (
    <div className="modal-overlay"  onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title" style={{transform:isMobile?"translateX(15%)":"translateX(25%)"}} >Allotment Confirmation</h2>
          <button className="modal-close" onClick={onClose}>
            <span style={{ color: "#9fa6b3" }}>X</span>
          </button>
        </div>

        <div className="modal-body">
          
          <div style={{ width: "100%" }}>
            <div
             
              style={{ backgroundColor: "#f7f9fa", margin: "0px" }}
            >
              <div className="unit-info">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "10px",
                  }}
                >
                  <div className="unit-building">
                    {unitData?.displayName}
                  </div>
                
               <div className="unit-project">
                 - {unitData?.unitNo}
                  </div>
                   <div className="unit-project">
                    |
                  </div>
                  <div className="unit-project">
                    {unitData?.description|| "Lavinto (M15)"}
                  </div>
                </div>

                   <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",  
                    padding: "0px 10px 10px 10px",
                  }}
                >
                  <span className="unit-project" style={{color:"#667085",padding:"0px"}}>
                    {unitData?.title}  |
                  </span>
                
               <span className="unit-project" style={{color:"#667085"}}>
                 {unitData?.unitType}  |
                  </span>
                   <div className="unit-project" style={{color:"#667085"}}>
                    {unitData?.floorNo}  |
                  </div>
                  <div className="unit-project" style={{color:"#667085"}}>
                 {/* {  token no} */}{tokenNo}
                  </div>
                </div>
                <div
                  className={cssClasses.cardFooter}
                  style={{ paddingLeft: "10px" }}
                >
                  {/* <div
                    className={cssClasses.cardFooterAmount}
                    style={{ borderRadius: "7px", backgroundColor: "white" }}
                  >
                    <div className="unit-details">
                      <span style={{fontSize:"12px",fontWeight:"bold"}}>{unitData?.unitId?.inventoryTypeId?.type}</span>
                      <span style={{fontSize:"12px",fontWeight:"bold"}}>{unitData?.unitId?.floorNo}</span>
                    </div>
                  </div> */}
                </div>
                <div
                  style={{
                    padding: "10px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div className={cssClasses.cardFooter}>
                    <div
                      className={cssClasses.cardFooterAmount}
                      style={{ backgroundColor: "white"}}
                    >
                      <div className="unit-cost">
                        <div className="cost-label">Total Carpet Area</div>
                        <div className="cost-amount">
                           
                          {Math.floor(unitData?.chargeableArea * 10.7639)} sqft.
                          {/* {unitData?.chargeableArea} */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={cssClasses.cardFooter}>
                    <div
                      className={cssClasses.cardFooterAmount}
                      style={{ backgroundColor: "white", marginLeft: "20px" }}
                    >
                      <div className="unit-cost">
                        <div className="cost-label">Total Unit Cost</div>
                        <div className="cost-amount">
                          ₹ {formatIndianNumber(unitData?.totalCost)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <input
            type="checkbox"
            style={{
              width: "15px",
              height: "15px",
              borderRadius: "50%",
              border: "2px solid #1670f0",
              cursor: "pointer",
              backgroundColor: "white",
              transform:
                "translateY(25%)" /* Space between radio button and text */,
            }}
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
          />
          <span
            style={{ fontSize: isMobile ? "1.5rem" : "", color: "#798294" }}
          >
            I agree to the{" "}
           <a
  href="#"
  style={{
    textDecoration: "none",
    fontWeight: 500,
    color: "#1670f0",
    cursor: "pointer",
  }}
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation(); // ✅ prevents the parent modal overlay from closing
    handleOpenDialog(e); // ✅ opens the dialog
  }}
>
  Terms and Conditions
</a>

          </span>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="confirmation-note" style={{ color: "#798294" ,textAlign:"center"}}>
          
               The token amount will be adjusted in your final payment after completion
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <Button
            variant="outlined"
            color="primary"
            onClick={onClose}
            style={{ fontSize: isMobile ? "1.5rem" : "" }}
          >
            Go Back
          </Button>
         <Button
  variant="contained"
  color="primary"
  onClick={handleConfirm}
  disabled={!termsAccepted || showSuccessModal} // 👈 disable when success modal open
  style={{
    fontSize: isMobile ? "1.5rem" : "",
    width: 100,
    visibility: showSuccessModal ? "hidden" : "visible", // 👈 hide loader/button
  }}
>
  {!showSuccessModal && (
    loading ? (
      <CircularProgress size={24} color="inherit" />
    ) : (
      "Confirm"
    )
  )}
</Button>

        </div>
      </div>
      {/* 🔹 Modal for "Unit Not Available" */}
      <UnitNotAvailableModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        status={falseStatus}
        tokenNo={tokenNo}
        paymentId={paymentId}
      />
      {/* dialog box for terms and conditions */}
      <Dialog
  open={openDialog}
  onClose={handleCloseDialog}
  sx={{
    zIndex: 2500, // ensures it appears on top
    maxWidth: "500px",
    margin: "auto",
    borderRadius: "10px",
  }}
>

  <DialogContent
    sx={{
      padding: "16px 24px",
      fontSize: "1.6rem",
      color: "#333",
      lineHeight: "1.8",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "stretch",
    }}
  >
    {/* Header */}
    <Box
      sx={{
        backgroundColor: "#e3f2fd",
        padding: "10px",
        borderRadius: "10px",
        width: "100%",
        textAlign: "center",
        marginBottom: "16px",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: "1.8rem",
          fontWeight: "bold",
          color: "#1976d2",
        }}
      >
        Online Booking Terms & Conditions
      </Typography>
    </Box>

    {/* Terms & Conditions */}
   <Typography
  variant="body1"
  sx={{
    fontSize: "1.5rem",
    color: "#555",
    marginBottom: "16px",
    lineHeight: "1.8",
    textAlign: "justify",
  }}
>
  <strong>VJ Indieworks – Online Booking Event Terms & Conditions</strong>
  <br />
  <br />
  1. The Event will be active on <strong>31-10-2025</strong>, unless extended or closed earlier by the Organizer.
  <br />
  <br />
  2. Bookings can be made online through the official website{" "}
  <Link
    href="https://customer.vjerp.com/" // 🔗 Replace with your actual booking URL
    target="_blank"
    rel="noopener noreferrer"
    sx={{ color: "#1570EF", textDecoration: "none", fontWeight: 500 }}
  >
    https://customer.vjerp.com/
  </Link>{" "}
  or any authorized booking link shared by the Organizer.
  <br />
  <br />
  3. A unit shall be considered temporarily reserved only upon successful completion 
  of the initial booking process and receipt of the booking amount within the prescribed time.
  <br />
  <br />
  4. The booking amount or token payment must be completed within 
  <strong> 15 minutes</strong> of initiating the booking. Failure to make payment within 
  the stipulated time shall result in automatic release or cancellation of the reserved unit 
  without prior notice.
  <br />
  <br />
  5. A booking is deemed confirmed only upon receipt of full payment of the booking amount 
  and issuance of an official confirmation email or receipt by the Organizer.
  <br />
  <br />
  6. Booking confirmation does not guarantee allotment until all documentation and verification, 
  including KYC and internal approval, are successfully completed.
  <br />
  <br />
  7. In case of cancellation by the Applicant, the booking amount is refundable but may be subject 
  to cancellation charges under certain conditions as per company policy.
  <br />
  <br />
  8. The Organizer reserves the right to cancel any booking due to incomplete payment, 
  documentation issues, or non-compliance with these Terms.
  <br />
  <br />
  9. Any offers, discounts, or benefits under this Event are valid only during the Event Period 
  and are subject to availability.
  <br />
  <br />
  10. By participating, the Applicant consents to receive calls, messages, and emails from 
  <strong> Vilas Javdekar Developers</strong> and its authorized partners regarding the booking or related offers.
  <br />
  <br />
  11. The Organizer shall not be responsible for technical glitches, server downtime, or payment failures 
  occurring due to third-party payment gateways or internet issues.
  <br />
  <br />
  12. <strong> Vilas Javdekar Developers</strong> reserves the right to withdraw, modify, or terminate the Event 
  at any time without prior notice.
  <br />
  <br />
  13. Any disputes arising out of or in connection with this Event shall be subject to 
  <strong> Pune jurisdiction</strong> only.
  <br />
  <br />
  14. By proceeding with the booking, the Applicant confirms that they have read, understood, 
  and accepted these Terms & Conditions.
</Typography>
  </DialogContent>

  {/* Dialog Actions */}
  <DialogActions
    sx={{
      padding: "8px 16px",
      justifyContent: "flex-end",
      backgroundColor: "#f7f7f7",
      borderBottomLeftRadius: "10px",
      borderBottomRightRadius: "10px",
    }}
  >
   <Button
  onClick={(e) => {
    e.stopPropagation(); // ✅ prevent parent modal from receiving the click
    handleCloseDialog();
  }}
  color="primary"
  sx={{
    fontSize: "1.3rem",
    fontWeight: 600,
    padding: "8px 16px",
    backgroundColor: "#1976d2",
    color: "#fff",
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  }}
>
  Close
</Button>

  </DialogActions>

  {/* Custom Styles */}
  <style>
    {`
      .MuiDialog-paper {
        border-radius: 10px;
        border: 1px solid #1976d2;
      }
    `}
  </style>
</Dialog>

  <UnitUnavailableDialog
      open={isModalOpenForRPC}
      onClose={handleCloseDialogForRPC}
    />

    </div>
    
  );
};

export default ConfirmUnitModal;
